module.exports = "/_next/static/images/6fd94323e27200b5acc467cc0818ab0d-medium-reuters.png";